import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialBookUpdate from "../social_book_update";
import PreviewBook from "../../preview_book/preview_book";
import ExpandableHtml from "../../user_content/expandable_html";
import SharingNonBookDetails from "./sharing_nonbook_details";

export default GrComponentFactory.createClass({
  displayName: "SharingNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      sharingText: React.PropTypes.shape(GrPropTypes.expandableHtml()),
      sharingResource: React.PropTypes.shape({
        resourceType: React.PropTypes.string.isRequired,
        resourceTypeFriendlyText: React.PropTypes.string.isRequired,
        item: React.PropTypes.object.isRequired,
      }).isRequired,
      user: GrPropTypes.user().isRequired,
    }).isRequired,
  },

  renderHeader() {
    let sharingResourceHeader;
    const sharingResource = this.props.resource.sharingResource;
    if (sharingResource.resourceType === "Book") {
      sharingResourceHeader = (
        <a className="gr-hyperlink gr-hyperlink--bold"
           href={sharingResource.item.bookUrl}>
          {sharingResource.item.title}
        </a>
      );

    } else if (sharingResource.resourceType === "Topic") {
      const group = sharingResource.item.group;
      sharingResourceHeader = (
        <span>
        {`this ${sharingResource.resourceTypeFriendlyText} in `}
          <a aria-label={`Go to group ${group.name}`}
             className="gr-hyperlink gr-hyperlink--bold"
             href={group.url}>
            {group.name}
          </a>
        </span>
      );

    } else {
      sharingResourceHeader = <span>
        this {sharingResource.resourceTypeFriendlyText}
      </span>;
    }
    return (
      <span className="gr-newsfeedItem__headerText">shared {sharingResourceHeader}</span>
    );
  },

  renderSharingText() {
    if (this.props.resource.sharingText) {
      return(
        <div className="feedItemSharingText">
          <ExpandableHtml {...this.props.resource.sharingText} />
        </div>
      );
    }
    else
    {
      return null;
    }
  },

  renderNonBookBody() {
    return (
      <div className="gr-newsfeedItem__sharingNonBookBody">
        {this.renderSharingText()}
        <SharingNonBookDetails {...this.props.resource.sharingResource} />
      </div>
    );
  },

  render() {
    const header = this.renderHeader();
    if (this.props.resource.sharingResource.resourceType == "Book") {
      return (
        <SocialBookUpdate
          header={header}
          book={this.props.resource.sharingResource.item}
          updateDetails={this.renderSharingText()}
          showBookBorder={true}
          additionalFooterLinks={[<PreviewBook book={this.props.resource.sharingResource.item}/>]}
          {...this.props}
        />
      );
    } else {
      return (
        <SocialUpdate
          header={header}
          body={this.renderNonBookBody()}
          {...this.props}
        />
      );
    }
  },
});
